import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'FeedbackIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    boxSize: 6,
  },
  path: (
    <path
      d="M8.375 9.75C8.375 9.95711 8.20711 10.125 8 10.125C7.79289 10.125 7.625 9.95711 7.625 9.75C7.625 9.54289 7.79289 9.375 8 9.375C8.20711 9.375 8.375 9.54289 8.375 9.75ZM8.375 9.75H8M12.125 9.75C12.125 9.95711 11.9571 10.125 11.75 10.125C11.5429 10.125 11.375 9.95711 11.375 9.75C11.375 9.54289 11.5429 9.375 11.75 9.375C11.9571 9.375 12.125 9.54289 12.125 9.75ZM12.125 9.75H11.75M15.875 9.75C15.875 9.95711 15.7071 10.125 15.5 10.125C15.2929 10.125 15.125 9.95711 15.125 9.75C15.125 9.54289 15.2929 9.375 15.5 9.375C15.7071 9.375 15.875 9.54289 15.875 9.75ZM15.875 9.75H15.5M2 12.7593C2 14.3604 3.12341 15.754 4.70746 15.987C5.79357 16.1467 6.89151 16.27 8 16.3556V21L12.1835 16.8165C12.3902 16.6098 12.6693 16.4923 12.9616 16.485C14.9372 16.4361 16.8831 16.2678 18.7925 15.9871C20.3766 15.7542 21.5 14.3606 21.5 12.7595V6.74056C21.5 5.13946 20.3766 3.74583 18.7925 3.51293C16.494 3.17501 14.1426 3 11.7503 3C9.35776 3 7.00612 3.17504 4.70747 3.51302C3.12342 3.74593 2 5.13956 2 6.74064V12.7593Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      fill="none"
    />
  ),
});
